import { DatePickerInput as MDatePickerInput } from '@mantine/dates';
import classes from './datePickerInput.module.scss';

export const DatePickerInput = MDatePickerInput.extend({
  classNames: classes,
  defaultProps: {
    valueFormat: 'DD.MM.YYYY',
    popoverProps: { classNames: classes },
  },
});
